import { render, staticRenderFns } from "./thumbnails.vue?vue&type=template&id=3bfbe5a4&"
import script from "./thumbnails.vue?vue&type=script&lang=ts&"
export * from "./thumbnails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports